import React from 'react'
import { Button, makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'
import { useSelectionStoreManager } from 'context/HomeStore/Manager/SelectionProvider/SelectionProvider.manager'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    right: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 32,
    flexDirection: 'column',
    padding: 32,
    backgroundColor: PRIMARY_COLORS[100],
    borderRadius: 12
  },
  title: {
    color: GRAY_COLORS[700],
    fontSize: 16,
    fontWeight: 600
  },
  count: {
    color: GRAY_COLORS[700],
    fontSize: 36,
    fontWeight: 600,
    lineHeight: '44px'
  }
}))
const Queue = () => {
  const classes = useStyle()
  const { selectionStore, selectionStoreFunc } = useSelectionStoreManager()
  return (
    <div className={classes.rootDiv}>
      <LoaderBackdrop loading={selectionStore.loading} />
      <div className={classes.card}>
        <div className={classes.title}>Вас ожидает клиент</div>
        <div className={classes.count}>{selectionStore.queue || 0}</div>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={selectionStoreFunc.inviteClient}
        >
          Принять клиента
        </Button>
      </div>
    </div>
  )
}
export default Queue
